/**
 * KOSTCH New Leaf Protection Plan — card select, Learn More modal, ATC with warranty.
 */
(function () {
  function selectedWarrantyId(root) {
    var checked = root.querySelector('[data-kostch-protection-variant]:checked');
    return checked ? checked.value : null;
  }

  function syncCardState(root) {
    root.querySelectorAll('.kostch-protection__card').forEach(function (card) {
      var input = card.querySelector('[data-kostch-protection-variant]');
      card.classList.toggle('is-selected', !!(input && input.checked));
    });
  }

  function parsePlansMap(root) {
    var script = root.querySelector('[data-kostch-protection-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function tierKeyFromPrice(rawPrice, map) {
    var cents = Number(rawPrice);
    if (!isFinite(cents) || cents < 0) return (map && map.tierKeys && map.tierKeys[0]) || 'U500';

    var thresholds = (map && map.thresholds) || [50000, 150000, 300000, 500000];
    var keys = (map && map.tierKeys) || ['U500', 'U1500', 'U3000', 'U5000', 'U7500'];
    for (var i = 0; i < thresholds.length; i++) {
      if (cents < thresholds[i]) return keys[i];
    }
    return keys[keys.length - 1];
  }

  function tierHintLabel(tierKey, map) {
    if (map && map.tierLabels && map.tierLabels[tierKey]) {
      return 'Based on this appliance price · ' + map.tierLabels[tierKey];
    }
    if (!tierKey) return '';
    return 'Based on this appliance price · under $' + String(tierKey).replace(/^U/i, '');
  }

  function applyTierToCards(root, tierKey) {
    var map = parsePlansMap(root);
    if (!map || !map.plans) return;

    var tier = map.plans[tierKey];
    if (!tier) return;

    root.setAttribute('data-tier', tierKey);

    var hint = root.querySelector('[data-kostch-protection-tier-hint]');
    if (hint) hint.textContent = tierHintLabel(tierKey, map);

    var anyVisible = false;
    ['3', '5'].forEach(function (year) {
      var card = root.querySelector('.kostch-protection__card[data-plan-year="' + year + '"]');
      var input = root.querySelector('[data-kostch-protection-variant][data-plan-year="' + year + '"]');
      if (!card || !input) return;

      var plan = tier[year];
      if (!plan || !plan.id) {
        card.hidden = true;
        card.classList.add('is-disabled');
        input.disabled = true;
        input.checked = false;
        input.value = '';
        return;
      }

      anyVisible = true;
      card.hidden = false;
      card.classList.remove('is-disabled');
      input.disabled = false;
      input.value = String(plan.id);
      // Keep checked state only if this input was already selected; never auto-select on tier sync.

      var priceEl = card.querySelector('[data-plan-price]');
      var skuEl = card.querySelector('[data-plan-sku]');
      if (priceEl) priceEl.textContent = plan.price || '';
      if (skuEl) skuEl.textContent = plan.sku || '';
    });

    // If the checked radio was disabled/cleared above, ensure UI matches.
    var stillChecked = root.querySelector('[data-kostch-protection-variant]:checked');
    if (stillChecked && stillChecked.disabled) {
      stillChecked.checked = false;
    }

    root.hidden = !anyVisible;
    syncCardState(root);
  }

  function bindVariantPriceSync(root) {
    var form = getForm(root);
    if (!form || form.getAttribute('data-kostch-protection-price-bound') === '1') return;
    form.setAttribute('data-kostch-protection-price-bound', '1');

    form.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var price = variant.price;
      if (price == null && variant.price_in_cents != null) price = variant.price_in_cents;
      var map = parsePlansMap(root);
      var tierKey = tierKeyFromPrice(price, map);
      applyTierToCards(root, tierKey);
      syncOfferMeta(root, variant);
    });
  }

  function openModal(root) {
    var dialog = root.querySelector('[data-kostch-protection-modal]');
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('kostch-protection-open');
  }

  function closeModal(root) {
    var dialog = root.querySelector('[data-kostch-protection-modal]');
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('kostch-protection-open');
  }

  function setTab(root, name) {
    root.querySelectorAll('[data-kostch-protection-tab]').forEach(function (tab) {
      var active = tab.getAttribute('data-kostch-protection-tab') === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-kostch-protection-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-kostch-protection-panel') === name;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  function getForm(root) {
    var formId = root.getAttribute('data-form-id');
    return formId ? document.getElementById(formId) : null;
  }

  function getQuantity(form) {
    if (!form) return 1;
    var qty = form.querySelector('[name="quantity"]');
    var n = qty ? parseInt(qty.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function parseJsonResponse(res) {
    return res.text().then(function (text) {
      if (res.status === 429) {
        throw {
          description: 'Too many cart requests. Please wait about a minute, then try again.',
          status: 429
        };
      }
      var data;
      try {
        data = JSON.parse(text);
      } catch (error) {
        throw {
          description: 'Could not update cart. Please refresh the page and try again.',
          status: res.status
        };
      }
      if (!res.ok) throw data;
      return data;
    });
  }

  function getMainVariantId(form) {
    if (form.id && form.id.value) {
      var fromNamed = parseInt(form.id.value, 10);
      if (fromNamed) return fromNamed;
    }
    var enabled = form.querySelector('input[name="id"]:not([disabled])');
    if (enabled && enabled.value) return parseInt(enabled.value, 10);
    var any = form.querySelector('input[name="id"]');
    if (any && any.value) return parseInt(any.value, 10);
    return NaN;
  }

  function clearWarrantySelection(root) {
    root.querySelectorAll('[data-kostch-protection-variant]').forEach(function (input) {
      input.checked = false;
      input.removeAttribute('data-kostch-was-checked');
    });
    syncCardState(root);
  }

  function formatDeliveryRange(minDays, maxDays) {
    function addDays(base, days) {
      var d = new Date(base.getTime());
      d.setDate(d.getDate() + days);
      return d;
    }
    function fmt(d) {
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
    var now = new Date();
    var a = addDays(now, minDays);
    var b = addDays(now, maxDays);
    if (a.getMonth() === b.getMonth()) {
      return a.toLocaleDateString('en-US', { month: 'short' }) + ' ' + a.getDate() + '–' + b.getDate();
    }
    return fmt(a) + '–' + fmt(b);
  }

  function preorderRecord(root, variant) {
    if (!variant || variant.id == null) return null;
    var mapEl = root.querySelector('[data-kostch-preorder-days]');
    if (!mapEl) return null;
    try {
      var map = JSON.parse(mapEl.textContent);
      var row = map[String(variant.id)];
      if (row && typeof row === 'object') return row;
      if (typeof row === 'number') return { days: row, preorder: false };
      return null;
    } catch (error) {
      return null;
    }
  }

  function isPreorderVariant(root, variant) {
    if (!variant || variant.available === false) return false;
    var row = preorderRecord(root, variant);
    if (row) return row.preorder === true;
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;
    return !!(variant.inventory_management && variant.inventory_policy === 'continue' && qty <= 0);
  }

  function preorderExtraDays(root, variant) {
    var shipEl = root.querySelector('[data-kostch-protection-shipping]');
    if (!variant) {
      return parseInt(shipEl && shipEl.getAttribute('data-preorder-extra'), 10) || 0;
    }
    if (!isPreorderVariant(root, variant)) return 0;
    var row = preorderRecord(root, variant);
    var days = row ? parseInt(row.days, 10) : 0;
    return isNaN(days) || days < 0 ? 0 : days;
  }

  function syncFulfillment(root, variant) {
    var stockEl = root.querySelector('[data-kostch-protection-stock]');
    var rangeEl = root.querySelector('[data-kostch-delivery-range]');
    var shipEl = root.querySelector('[data-kostch-protection-shipping]');
    if (stockEl && variant) {
      var available = variant.available !== false;
      var preorder = isPreorderVariant(root, variant);
      stockEl.textContent = !available ? 'Sold Out' : (preorder ? 'Pre-order' : 'In Stock');
      if (available) stockEl.removeAttribute('data-out-of-stock');
      else stockEl.setAttribute('data-out-of-stock', '');
    }
    if (rangeEl && shipEl) {
      var extraDays = preorderExtraDays(root, variant);
      var minDays = (parseInt(shipEl.getAttribute('data-min-days'), 10) || 5) + extraDays;
      var maxDays = (parseInt(shipEl.getAttribute('data-max-days'), 10) || 10) + extraDays;
      if (maxDays < minDays) maxDays = minDays;
      rangeEl.textContent = formatDeliveryRange(minDays, maxDays);
    }
  }

  /**
   * Add appliance + warranty in one Cart API call (Shopify docs).
   * Do NOT use bundled sections here — Prestige CartDrawer.replaceContent(innerHTML)
   * corrupts line items whose titles/alts contain `"`. Refresh drawer via cart:refresh.
   */
  function addItemsLikePrestige(items) {
    var root = shopifyRoot();

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(parseJsonResponse)
      .then(function (addData) {
        return fetch(root + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            return res.text().then(function (text) {
              if (!res.ok || res.status === 429) {
                return {
                  addData: addData,
                  cart: {
                    item_count: (addData.items || []).reduce(function (sum, item) {
                      return sum + (item.quantity || 1);
                    }, 0),
                    items: addData.items || []
                  }
                };
              }
              try {
                return { addData: addData, cart: JSON.parse(text) };
              } catch (error) {
                return {
                  addData: addData,
                  cart: { item_count: 0, items: addData.items || [] }
                };
              }
            });
          })
          .catch(function () {
            return {
              addData: addData,
              cart: { item_count: 0, items: addData.items || [] }
            };
          });
      });
  }

  function cartHasVariantId(cart, variantId) {
    var id = parseInt(variantId, 10);
    if (!cart || !cart.items || !id) return false;
    return cart.items.some(function (item) {
      return item.variant_id === id || item.id === id;
    });
  }

  function openCartAfterAdd(form, result) {
    var cart = result.cart;
    var addData = result.addData;

    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
      window.location.href = shopifyRoot() + 'cart';
      return;
    }

    form.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: addData.items || [addData],
          cart: cart
        }
      })
    );

    // Never dispatch cart:change with sections — drawer HTML breaks on 36" titles.
    updateCartCountUi(cart.item_count || 0);

    var drawer = document.querySelector('cart-drawer');
    var opened = false;
    function showDrawer() {
      if (opened) return;
      opened = true;
      if (drawer && typeof drawer.show === 'function') drawer.show();
    }

    if (drawer) {
      drawer.addEventListener('cart-drawer:refreshed', function onRefreshed() {
        drawer.removeEventListener('cart-drawer:refreshed', onRefreshed);
        showDrawer();
      });
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    window.setTimeout(showDrawer, 600);
  }

  function friendlyCartError(err) {
    var message = (err && (err.description || err.message)) || 'Unable to add to cart.';
    var lower = String(message).toLowerCase();
    if (lower.indexOf('too many') !== -1 || (err && err.status === 429)) {
      return 'Too many cart requests. Please wait about a minute, then try again.';
    }
    if (lower.indexOf('maximum quantity') !== -1 || lower.indexOf('already in your cart') !== -1) {
      return 'This item is already at max quantity in your cart. Open the cart, remove it, then try again.';
    }
    if (String(message).indexOf('Unexpected token') === 0) {
      return 'Could not update cart. Please refresh the page and try again.';
    }
    return message;
  }

  var OFFER_SEEN_KEY = 'kostch-protection-offer-seen';

  function formatMoney(cents) {
    var value = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(value);
      } catch (error) {}
    }
    var amount = (value / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function offerImageUrl(variant) {
    if (!variant) return '';
    var media = variant.featured_media || variant.featured_image || null;
    if (!media) return '';
    var src =
      (media.preview_image && (media.preview_image.src || media.preview_image.url)) ||
      media.src ||
      media.url ||
      '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src;
  }

  function readSeenIds() {
    try {
      var raw = sessionStorage.getItem(OFFER_SEEN_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function wasSeen(productId) {
    if (!productId) return false;
    return readSeenIds().indexOf(String(productId)) !== -1;
  }

  function markSeen(productIds) {
    var set = {};
    readSeenIds().forEach(function (id) {
      set[id] = true;
    });
    (productIds || []).forEach(function (id) {
      if (id) set[String(id)] = true;
    });
    try {
      sessionStorage.setItem(OFFER_SEEN_KEY, JSON.stringify(Object.keys(set)));
    } catch (error) {}
  }

  function mergeCartItems(items) {
    var map = {};
    var order = [];
    (items || []).forEach(function (item) {
      var id = parseInt(item && item.id, 10);
      var qty = parseInt(item && item.quantity, 10);
      if (!id || qty < 1) return;
      var key = String(id);
      if (!map[key]) {
        map[key] = { id: id, quantity: 0 };
        order.push(key);
      }
      map[key].quantity += qty;
    });
    return order.map(function (key) {
      return map[key];
    });
  }

  function syncOfferMeta(root, variant) {
    if (!root || !variant) return;
    if (variant.sku) root.setAttribute('data-product-sku', variant.sku);
    var cents = variant.price;
    if (cents == null && variant.price_in_cents != null) cents = variant.price_in_cents;
    if (cents != null && isFinite(Number(cents))) {
      root.setAttribute('data-product-price-cents', String(cents));
      root.setAttribute('data-product-price', formatMoney(cents));
    }
    var img = offerImageUrl(variant);
    if (img) root.setAttribute('data-product-image', img);
  }

  function lineFromRoot(root) {
    var form = getForm(root);
    var cents = parseInt(root.getAttribute('data-product-price-cents') || '0', 10) || 0;
    return {
      productId: root.getAttribute('data-product-id') || '',
      variantId: getMainVariantId(form),
      title: root.getAttribute('data-product-title') || '',
      sku: root.getAttribute('data-product-sku') || '',
      image: root.getAttribute('data-product-image') || '',
      priceCents: cents,
      priceLabel: root.getAttribute('data-product-price') || formatMoney(cents),
      quantity: getQuantity(form)
    };
  }

  function planForLine(root, line) {
    var map = parsePlansMap(root);
    if (!map || !map.plans) return null;
    return map.plans[tierKeyFromPrice(line.priceCents, map)] || null;
  }

  function textEl(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function ensureOfferDialog() {
    var dialog = document.querySelector('[data-kostch-offer]');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'kostch-offer';
    dialog.setAttribute('data-kostch-offer', '');

    var panel = document.createElement('div');
    panel.className = 'kostch-offer__panel';

    var head = document.createElement('div');
    head.className = 'kostch-offer__head';
    var brands = document.createElement('div');
    brands.className = 'kostch-offer__brands';
    brands.appendChild(textEl('span', 'kostch-offer__wordmark', 'KOSTCH'));
    var rule = document.createElement('span');
    rule.className = 'kostch-offer__rule';
    rule.setAttribute('aria-hidden', 'true');
    brands.appendChild(rule);
    var logo = document.createElement('img');
    logo.className = 'kostch-offer__logo';
    logo.alt = 'new leaf, an employee-owned company';
    logo.width = 148;
    logo.height = 48;
    brands.appendChild(logo);
    head.appendChild(brands);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'kostch-offer__close';
    closeBtn.setAttribute('data-kostch-offer-close', '');
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×';
    head.appendChild(closeBtn);
    panel.appendChild(head);

    panel.appendChild(textEl('h2', 'kostch-offer__title', 'Protection Plans'));
    panel.appendChild(
      textEl('p', 'kostch-offer__sub', 'Choose a protection plan for your KOSTCH appliance.')
    );

    var rows = document.createElement('div');
    rows.className = 'kostch-offer__rows';
    rows.setAttribute('data-kostch-offer-rows', '');
    panel.appendChild(rows);

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'kostch-offer__add';
    addBtn.setAttribute('data-kostch-offer-add', '');
    addBtn.textContent = 'Add Selected Plans';
    panel.appendChild(addBtn);

    var skipBtn = document.createElement('button');
    skipBtn.type = 'button';
    skipBtn.className = 'kostch-offer__skip';
    skipBtn.setAttribute('data-kostch-offer-skip', '');
    skipBtn.textContent = 'Continue Without Protection';
    panel.appendChild(skipBtn);

    var learn = document.createElement('a');
    learn.className = 'kostch-offer__learn';
    learn.setAttribute('data-kostch-offer-learn', '');
    learn.href = 'https://www.newleafsc.net/kostch/terms/';
    learn.target = '_blank';
    learn.rel = 'noopener noreferrer';
    learn.textContent = 'Learn More';
    panel.appendChild(learn);

    dialog.appendChild(panel);
    document.body.appendChild(dialog);

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      settleOffer(dialog, null, false);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        settleOffer(dialog, null, false);
        return;
      }
      if (event.target.closest('[data-kostch-offer-close]')) {
        event.preventDefault();
        settleOffer(dialog, null, false);
        return;
      }
      if (event.target.closest('[data-kostch-offer-skip]')) {
        event.preventDefault();
        settleOffer(dialog, [], true);
        return;
      }
      if (event.target.closest('[data-kostch-offer-add]')) {
        event.preventDefault();
        settleOffer(dialog, selectedOfferPlans(dialog), true);
        return;
      }

      var card = event.target.closest('[data-offer-plan]');
      if (!card || !dialog.contains(card)) return;
      var input = card.querySelector('input');
      if (!input || input.disabled) return;
      if (input.checked && input.getAttribute('data-offer-was-checked') === '1') {
        event.preventDefault();
        input.checked = false;
        input.removeAttribute('data-offer-was-checked');
        card.classList.remove('is-selected');
      }
    });

    dialog.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('[data-offer-input]')) return;
      var row = input.closest('[data-offer-row]');
      if (!row) return;
      row.querySelectorAll('[data-offer-plan]').forEach(function (card) {
        var radio = card.querySelector('input');
        var on = radio === input && input.checked;
        card.classList.toggle('is-selected', on);
        if (radio && radio !== input) radio.removeAttribute('data-offer-was-checked');
      });
      if (input.checked) input.setAttribute('data-offer-was-checked', '1');
    });

    return dialog;
  }

  function closeOfferDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('kostch-offer-open');
  }

  function settleOffer(dialog, planItems, shouldResolve) {
    if (!dialog || dialog._offerSettled) return;
    dialog._offerSettled = true;
    markSeen(
      (dialog._offerLines || []).map(function (line) {
        return line.productId;
      })
    );
    var resolve = dialog._offerResolve;
    closeOfferDialog(dialog);
    if (shouldResolve && typeof resolve === 'function') resolve(planItems || []);
  }

  function selectedOfferPlans(dialog) {
    var items = [];
    dialog.querySelectorAll('[data-offer-row]').forEach(function (row) {
      var checked = row.querySelector('[data-offer-input]:checked');
      if (!checked || !checked.value) return;
      var qty = parseInt(row.getAttribute('data-qty') || '1', 10) || 1;
      items.push({ id: parseInt(checked.value, 10), quantity: qty });
    });
    return mergeCartItems(items);
  }

  function renderOfferRows(dialog, root, lines) {
    var logo = dialog.querySelector('.kostch-offer__logo');
    if (logo) {
      var src = root.getAttribute('data-leaf-logo') || '';
      if (src) logo.src = src;
    }
    var learnLink = dialog.querySelector('[data-kostch-offer-learn]');
    if (learnLink) {
      learnLink.href = root.getAttribute('data-terms-url') || 'https://www.newleafsc.net/kostch/terms/';
    }

    var rows = dialog.querySelector('[data-kostch-offer-rows]');
    rows.textContent = '';
    var badgeSrc = root.getAttribute('data-badge-src') || '';
    var label3Node = root.querySelector('[data-plan-year="3"] .kostch-protection__card-label');
    var label5Node = root.querySelector('[data-plan-year="5"] .kostch-protection__card-label');
    var label3 = label3Node ? label3Node.textContent.trim() : '3 Years Protection Plan';
    var label5 = label5Node ? label5Node.textContent.trim() : '5 Years Protection Plan';

    lines.forEach(function (line, index) {
      var tier = planForLine(root, line) || {};
      var has5 = tier['5'] && tier['5'].id;
      var has3 = tier['3'] && tier['3'].id;
      var preferred = has5 ? '5' : has3 ? '3' : '';

      var row = document.createElement('div');
      row.className = 'kostch-offer__row';
      row.setAttribute('data-offer-row', '');
      row.setAttribute('data-qty', String(line.quantity || 1));

      var imgWrap = document.createElement('div');
      imgWrap.className = 'kostch-offer__photo';
      if (line.image) {
        var img = document.createElement('img');
        img.src = line.image;
        img.alt = '';
        imgWrap.appendChild(img);
      }
      row.appendChild(imgWrap);

      var info = document.createElement('div');
      info.className = 'kostch-offer__info';
      info.appendChild(textEl('p', 'kostch-offer__name', line.title || 'KOSTCH appliance'));
      if (line.sku) info.appendChild(textEl('p', 'kostch-offer__sku', 'SKU: ' + line.sku));
      info.appendChild(
        textEl(
          'p',
          'kostch-offer__price',
          'Product price: ' + (line.priceLabel || formatMoney(line.priceCents))
        )
      );
      row.appendChild(info);

      var plans = document.createElement('div');
      plans.className = 'kostch-offer__plans';
      plans.appendChild(textEl('p', 'kostch-offer__choose', 'Choose a protection plan'));
      var cards = document.createElement('div');
      cards.className = 'kostch-offer__cards';

      [
        { year: '3', plan: tier['3'], label: label3 },
        { year: '5', plan: tier['5'], label: label5 }
      ].forEach(function (entry) {
        var plan = entry.plan;
        var available = !!(plan && plan.id);
        var card = document.createElement('label');
        card.className = 'kostch-offer__card';
        card.setAttribute('data-offer-plan', '');
        if (!available) card.hidden = true;

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'kostch-offer-plan-' + index;
        input.setAttribute('data-offer-input', '');
        input.value = available ? String(plan.id) : '';
        input.disabled = !available;
        if (available && entry.year === preferred) {
          input.checked = true;
          input.setAttribute('data-offer-was-checked', '1');
          card.classList.add('is-selected');
        }
        card.appendChild(input);

        var inner = document.createElement('span');
        inner.className = 'kostch-offer__card-inner';
        if (badgeSrc) {
          var badge = document.createElement('img');
          badge.className = 'kostch-offer__badge';
          badge.alt = '';
          badge.src = badgeSrc;
          inner.appendChild(badge);
        }
        var copy = document.createElement('span');
        copy.className = 'kostch-offer__card-copy';
        copy.appendChild(textEl('span', 'kostch-offer__card-label', entry.label));
        copy.appendChild(textEl('span', 'kostch-offer__card-price', (plan && plan.price) || ''));
        inner.appendChild(copy);
        card.appendChild(inner);
        cards.appendChild(card);
      });

      plans.appendChild(cards);
      row.appendChild(plans);
      rows.appendChild(row);
    });
  }

  function openProtectionOffer(root, lines, options) {
    var pending = (lines || []).filter(function (line) {
      return line && line.productId && line.variantId && !wasSeen(line.productId);
    });
    if (!pending.length || !parsePlansMap(root)) return false;

    var dialog = ensureOfferDialog();
    if (dialog.open && !dialog._offerSettled) return true;

    renderOfferRows(dialog, root, pending);
    dialog._offerRoot = root;
    dialog._offerLines = pending;
    dialog._offerResolve = (options && options.onResolve) || function () {};
    dialog._offerSettled = false;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('kostch-offer-open');
    return true;
  }

  function submitOfferItems(form, items) {
    var merged = mergeCartItems(items);
    if (!form || !merged.length) return;

    var submitButtons = Array.from(form.elements).filter(function (el) {
      return el.type === 'submit';
    });
    submitButtons.forEach(function (btn) {
      btn.setAttribute('aria-busy', 'true');
    });
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var mainId = merged[0].id;
    addItemsLikePrestige(merged)
      .then(function (result) {
        if (!cartHasVariantId(result.cart, mainId)) {
          throw { description: 'The appliance was not added to the cart. Please try again.' };
        }
        openCartAfterAdd(form, result);
      })
      .catch(function (err) {
        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: friendlyCartError(err) }
          })
        );
      })
      .finally(function () {
        submitButtons.forEach(function (btn) {
          btn.removeAttribute('aria-busy');
        });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      });
  }

  function interceptAddToCart(root) {
    var form = getForm(root);
    if (!form || form.getAttribute('data-kostch-protection-bound') === '1') return;
    form.setAttribute('data-kostch-protection-bound', '1');

    form.addEventListener(
      'submit',
      function (event) {
        // No plan selected → do not intercept; Prestige product-form handles ATC alone.
        var warrantyId = selectedWarrantyId(root);
        if (!warrantyId) {
          if (!parsePlansMap(root)) return;
          var offerLine = lineFromRoot(root);
          if (!offerLine.variantId || !offerLine.productId || wasSeen(offerLine.productId)) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          openProtectionOffer(root, [offerLine], {
            onResolve: function (planItems) {
              submitOfferItems(
                form,
                [{ id: offerLine.variantId, quantity: offerLine.quantity }].concat(planItems || [])
              );
            }
          });
          return;
        }

        var mainVariantId = getMainVariantId(form);
        var warrantyVariantId = parseInt(warrantyId, 10);
        if (!mainVariantId || !warrantyVariantId || mainVariantId === warrantyVariantId) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var submitButtons = Array.from(form.elements).filter(function (el) {
          return el.type === 'submit';
        });
        submitButtons.forEach(function (btn) {
          btn.setAttribute('aria-busy', 'true');
        });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        var qty = getQuantity(form);
        var items = [
          { id: mainVariantId, quantity: qty },
          { id: warrantyVariantId, quantity: 1 }
        ];

        addItemsLikePrestige(items)
          .then(function (result) {
            if (!cartHasVariantId(result.cart, mainVariantId)) {
              throw {
                description:
                  'The appliance was not added to the cart. Clear the cart and try again, or add without a protection plan first.'
              };
            }
            if (!cartHasVariantId(result.cart, warrantyVariantId)) {
              throw {
                description:
                  'The protection plan was not added. Check plan inventory (or allow overselling), then try again.'
              };
            }
            openCartAfterAdd(form, result);
          })
          .catch(function (err) {
            form.dispatchEvent(
              new CustomEvent('cart:error', {
                bubbles: true,
                detail: { error: friendlyCartError(err) }
              })
            );
            // Never refresh after failed ATC (especially 429) — refresh amplifies rate limits.
          })
          .finally(function () {
            submitButtons.forEach(function (btn) {
              btn.removeAttribute('aria-busy');
            });
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          });
      },
      true
    );
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-kostch-protection-ready') === '1') return;
    root.setAttribute('data-kostch-protection-ready', '1');

    // Always start with no plan selected (opt-in). Prestige product-form handles ATC alone
    // until the shopper explicitly picks a protection plan.
    clearWarrantySelection(root);
    syncFulfillment(root, null);

    interceptAddToCart(root);
    bindVariantPriceSync(root);

    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-kostch-protection-variant]')) return;
      if (event.target.checked) {
        event.target.setAttribute('data-kostch-was-checked', '1');
        root.querySelectorAll('[data-kostch-protection-variant]').forEach(function (input) {
          if (input !== event.target) input.removeAttribute('data-kostch-was-checked');
        });
      }
      syncCardState(root);
    });

    // Click selected card again → clear plan (replaces "No protection plan" link)
    root.addEventListener(
      'click',
      function (event) {
        var card = event.target.closest('.kostch-protection__card');
        if (!card || !root.contains(card) || card.classList.contains('is-disabled')) return;
        var input = card.querySelector('[data-kostch-protection-variant]');
        if (!input || input.disabled) return;
        if (input.getAttribute('data-kostch-was-checked') === '1' || input.checked) {
          // If already selected, this click should deselect instead of keeping radio on
          if (input.checked && input.getAttribute('data-kostch-was-checked') === '1') {
            event.preventDefault();
            event.stopPropagation();
            clearWarrantySelection(root);
          }
        }
      },
      true
    );

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-kostch-protection-open]')) {
        event.preventDefault();
        openModal(root);
        return;
      }
      if (event.target.closest('[data-kostch-protection-close]')) {
        event.preventDefault();
        closeModal(root);
        return;
      }
      if (event.target.closest('[data-kostch-protection-clear]')) {
        event.preventDefault();
        clearWarrantySelection(root);
        return;
      }
      var tab = event.target.closest('[data-kostch-protection-tab]');
      if (tab) {
        event.preventDefault();
        setTab(root, tab.getAttribute('data-kostch-protection-tab'));
      }
    });

    var formForStock = getForm(root);
    if (formForStock) {
      formForStock.addEventListener('variant:change', function (event) {
        syncFulfillment(root, event.detail && event.detail.variant);
      });
    }

    var dialog = root.querySelector('[data-kostch-protection-modal]');
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeModal(root);
      });
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeModal(root);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('kostch-protection-plan').forEach(initRoot);
  }

  /* ---- Cart: external purchase platform + order number ---- */

  var noteSaveTimer = null;

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function updateCartCountUi(count) {
    document.querySelectorAll('cart-count').forEach(function (el) {
      try {
        el.itemCount = count;
      } catch (error) {
        el.textContent = String(count);
      }
    });
    document.querySelectorAll('cart-dot').forEach(function (el) {
      el.classList.toggle('is-visible', count > 0);
    });
  }

  var cartLineBusy = false;
  var cartRefreshTimer = null;

  function requestCartRefresh(delayMs) {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }, delayMs || 120);
  }

  /**
   * Prestige CartDrawer used to break on titles with `"`. theme.js replaceContent
   * now adopts DOM nodes (no innerHTML reparse). Own cart-drawer qty/remove anyway.
   */
  function changeCartLine(id, quantity) {
    if (cartLineBusy) {
      return Promise.reject({ description: 'Cart is updating. Please wait a moment.' });
    }
    cartLineBusy = true;
    var root = shopifyRoot();
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity
      })
    })
      .then(parseJsonResponse)
      .then(function (cart) {
        updateCartCountUi(cart.item_count || 0);
        requestCartRefresh(150);
        return cart;
      })
      .finally(function () {
        cartLineBusy = false;
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      });
  }

  function bindCartDrawerLineFixes() {
    if (document.documentElement.getAttribute('data-kostch-cart-line-fix') === '1') return;
    document.documentElement.setAttribute('data-kostch-cart-line-fix', '1');

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('cart-drawer a[href*="/cart/change"]');
        if (!link) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var url = new URL(link.href, window.location.origin);
        var id = url.searchParams.get('id');
        var quantity = parseInt(url.searchParams.get('quantity') || '0', 10);
        if (!id) return;

        changeCartLine(id, isNaN(quantity) ? 0 : quantity).catch(function (err) {
          if (err && err.status === 429) {
            window.alert(err.description || 'Too many cart requests. Please wait a few seconds.');
          }
          // Do not call cart:refresh here — that worsens 429 storms.
        });
      },
      true
    );

    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (!input || !input.getAttribute || !input.closest) return;
        if (!input.closest('cart-drawer')) return;
        if (!input.hasAttribute('data-line-key')) return;

        event.stopImmediatePropagation();

        var id = input.getAttribute('data-line-key');
        var quantity = parseInt(input.value, 10);
        if (!id) return;

        changeCartLine(id, isNaN(quantity) ? 0 : quantity).catch(function (err) {
          if (err && err.status === 429) {
            window.alert(err.description || 'Too many cart requests. Please wait a few seconds.');
          }
        });
      },
      true
    );
  }

  function saveWarrantyAttributes(platform, orderNumber) {
    return fetch(shopifyRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Purchase platform': platform || '',
          'Original order number': orderNumber || ''
        }
      })
    }).then(function (res) {
      return res.json();
    });
  }

  function readWarrantyFields(noteRoot) {
    var platform = noteRoot.querySelector('[data-kostch-warranty-platform]');
    var order = noteRoot.querySelector('[data-kostch-warranty-order]');
    return {
      platform: platform ? platform.value.trim() : '',
      order: order ? order.value.trim() : '',
      required: noteRoot.getAttribute('data-warranty-only') === 'true'
    };
  }

  function validateWarrantyNote(noteRoot, showError) {
    var fields = readWarrantyFields(noteRoot);
    var errorEl = noteRoot.querySelector('[data-kostch-warranty-error]');
    var ok = !fields.required || (fields.platform && fields.order);

    if (errorEl) {
      if (showError && !ok) errorEl.hidden = false;
      else if (ok) errorEl.hidden = true;
    }

    noteRoot.classList.toggle('is-invalid', showError && !ok);
    return ok;
  }

  function bindWarrantyNote(noteRoot) {
    if (!noteRoot || noteRoot.getAttribute('data-bound') === '1') return;
    noteRoot.setAttribute('data-bound', '1');

    noteRoot.addEventListener('input', function () {
      window.clearTimeout(noteSaveTimer);
      noteSaveTimer = window.setTimeout(function () {
        var fields = readWarrantyFields(noteRoot);
        saveWarrantyAttributes(fields.platform, fields.order).catch(function () {});
        validateWarrantyNote(noteRoot, false);
      }, 400);
    });
  }

  function initWarrantyCartNotes() {
    document.querySelectorAll('[data-kostch-warranty-note]').forEach(bindWarrantyNote);

    document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
      if (form.getAttribute('data-kostch-warranty-gate') === '1') return;
      form.setAttribute('data-kostch-warranty-gate', '1');

      form.addEventListener(
        'submit',
        function (event) {
          var submitter = event.submitter;
          var isCheckout =
            (submitter && submitter.getAttribute('name') === 'checkout') ||
            (event.submitter == null && form.querySelector('[name="checkout"]'));

          if (!isCheckout && submitter && submitter.getAttribute('name') !== 'checkout') {
            return;
          }

          var noteRoot = form.querySelector('[data-kostch-warranty-note]') || document.querySelector('[data-kostch-warranty-note]');
          if (!noteRoot || noteRoot.getAttribute('data-warranty-only') !== 'true') return;

          var fields = readWarrantyFields(noteRoot);
          if (!validateWarrantyNote(noteRoot, true)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            noteRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          saveWarrantyAttributes(fields.platform, fields.order)
            .then(function () {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'checkout';
              input.value = '';
              form.appendChild(input);
              HTMLFormElement.prototype.submit.call(form);
            })
            .catch(function () {
              HTMLFormElement.prototype.submit.call(form);
            });
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('DOMContentLoaded', initWarrantyCartNotes);
    document.addEventListener('DOMContentLoaded', bindCartDrawerLineFixes);
  } else {
    initAll();
    initWarrantyCartNotes();
    bindCartDrawerLineFixes();
  }

  document.addEventListener('product:rerender', function () {
    window.requestAnimationFrame(initAll);
  });

  document.addEventListener('cart:drawer:refreshed', initWarrantyCartNotes);
  document.addEventListener('cart-drawer:refreshed', initWarrantyCartNotes);
  document.addEventListener('cart:change', function () {
    window.setTimeout(initWarrantyCartNotes, 300);
  });

  window.KostchProtectionOffer = {
    prompt: function (lines, onResolve) {
      var root = document.querySelector('kostch-protection-plan');
      if (!root) return false;
      return openProtectionOffer(root, lines, { onResolve: onResolve });
    }
  };
})();
